"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Colorbar;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _react = require("react");
const _enums = require("../enums");
const { FAHRENHEIT, CELSIUS } = _enums.temperatureUnits;
const celsiusToFahrenheit = (value)=>{
    return value * 9 / 5 + 32;
};
const roundTo = (number = 0, decimalPlaces = 0)=>{
    if (typeof number !== "number" || typeof decimalPlaces !== "number") {
        throw new Error("Invalid arguments: number and decimalPlaces must be numbers");
    }
    try {
        return +number.toFixed(decimalPlaces);
    } catch (error) {
        console.error("An error occurred:", error);
    }
};
function Colorbar({ min = 0, max = 100, linearGradient = "", temperatureUnit = "C", width = 15, height = 480, color = "black", fontWeight = "bold" }) {
    const getFixedTemp = (0, _react.useCallback)((value)=>{
        value = value !== null && value !== void 0 ? value : 0;
        if (temperatureUnit === FAHRENHEIT) {
            value = celsiusToFahrenheit(value);
        }
        value = roundTo(value, 1);
        return value;
    }, [
        temperatureUnit
    ]);
    const getFormattedTemperature = (0, _react.useCallback)((value)=>{
        const temperature = getFixedTemp(value);
        return `— ${temperature} °${temperatureUnit !== null && temperatureUnit !== void 0 ? temperatureUnit : CELSIUS}`;
    }, [
        getFixedTemp,
        temperatureUnit
    ]);
    const sliderTickMarks = (0, _react.useMemo)(()=>{
        const numTicks = 10;
        const step = (max - min) / (numTicks - 1);
        const marks = [];
        for(let i = 0; i < numTicks; i++){
            const value = min + i * step;
            const label = getFormattedTemperature(value);
            marks.push({
                value,
                label
            });
        }
        return marks;
    }, [
        getFormattedTemperature,
        min,
        max
    ]);
    const styles = {
        gutter: {
            width: 85
        },
        slider: {
            position: "relative",
            minHeight: height - 4,
            maxHeight: height - 4,
            minWidth: width,
            maxWidth: width,
            margin: "0 -2px",
            backgroundImage: linearGradient,
            border: `2px solid ${color}`,
            borderRadius: 0,
            opacity: 1
        },
        tickMarker: (value)=>({
                position: "absolute",
                width: 100,
                left: width + 10,
                bottom: `${(value - min) / (max - min) * 100}%`,
                transform: "translateY(50%)",
                color: color,
                fontSize: "12px",
                fontWeight: fontWeight
            })
    };
    return /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
            style: styles.gutter,
            children: /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
                style: styles.slider,
                children: sliderTickMarks.map(({ value, label }, index)=>/*#__PURE__*/ (0, _jsxruntime.jsx)("span", {
                        style: styles.tickMarker(value),
                        children: label
                    }, `tick-label-${index}-${value}`))
            })
        })
    });
}
